var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractTypes from "./abstract";
var jQuery = require("jquery");
var Integer = /** @class */ (function (_super) {
    __extends(Integer, _super);
    function Integer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Integer.prototype.renderInput = function (rule) {
        var $el1 = rule.$el.find('.rule-value-container input:first');
        var $el2 = rule.$el.find('.rule-value-container input:eq(1)');
        $el1.on('blur change', function () {
            var minvalue = parseInt(jQuery(this).val());
            var maxvalue = parseInt($el2.val());
            if (maxvalue < minvalue) {
                $el2.val(minvalue);
            }
        });
        $el2.on('change', function () {
            var maxvalue = parseInt(jQuery(this).val());
            var minvalue = parseInt($el1.val());
            if (minvalue > maxvalue) {
                $el1.val(maxvalue);
            }
        });
    };
    return Integer;
}(AbstractTypes));
export default Integer;
